import { shallowRef } from 'vue';
export default {
    props: {
        message: String,
        type: String
    },
    setup(){
        const isShowToast = shallowRef(true);
        const closeToast = () => {
            isShowToast.value = false;
        }
        return{
            isShowToast,
            closeToast
        }
    }
}